import { useEffect, useState } from "react";
import StandingDetails from './StandingDetails.jsx'
import Pagination from './pagination/Pagination.jsx'
import { LoadStandings } from "../repo/GroupsRepo.js";

export default function MatchesList({tournamentId, groupId, matchesPage}) {
  const [standings, setStandings] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentMatchesPage, setCurrentMatchesPage] = useState(matchesPage || 1)

  function handlePaginationClick(newMatchesPage) {
    setCurrentMatchesPage(newMatchesPage)

    window.history.replaceState(null, "Bolão", "?tournament_id=" + tournamentId + "&group_id=" + groupId + "&matches_page=" + newMatchesPage)
  }

  async function loadStandings(groupId, currentMatchesPage) {
    const resData = await LoadStandings(groupId, currentMatchesPage)

    setStandings(resData.data)
    setPagination(resData.pagination)
  }

  useEffect(() => {
    if (!groupId) return

    loadStandings(groupId, currentMatchesPage)

    const intervalId = setInterval(() => {
      loadStandings(groupId, currentMatchesPage)
    }, 60000)

    return () => clearInterval(intervalId)
  }, [groupId, currentMatchesPage])


  return (
    <div className="flex flex-col space-y-4 bg-slate-100 rounded-lg">
      {standings.length > 0 &&
      <div className="overflow-x-auto mb-4 mx-4 rounded-lg border border-slate-300">
        {standings[0].points.diff != null && (
          <h3 className="text-center font-bold text-red-600 bg-white pt-2">Ao vivo</h3>
        )}
        <table className="w-full text-sm bg-white">
          <thead className="text-xs text-slate-700 bg-slate-50 text-right">
            <tr>
              <th scope="col" className="px-2 py-3">
                  #
              </th>
              <th scope="col" className="text-left px-2 py-3">
                  Participante
              </th>
              <th scope="col" className="px-2 py-3">
                  Pontos
              </th>
              <th scope="col" className="px-2 py-3">
                  10 pts
              </th>
              <th scope="col" className="px-2 py-3">
                  7 pts
              </th>
              <th scope="col" className="px-2 py-3">
                  5 pts
              </th>
              <th scope="col" className="px-2 py-3">
                  2 pts
              </th>
            </tr>
          </thead>
          <tbody>
            {standings.map((standingRow) => (
              <StandingDetails key={"standing-details-" + groupId + "|" + standingRow.user.id} groupId={groupId} standingRow={standingRow}/>
            ))}
          </tbody>
        </table>
      </div>
      }

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </div>
  )
}
